import React from 'react';
import cssmodules from 'react-css-modules';
import styles from './userspage.cssmodule.scss';
import UsersTable from './UsersTable';


class UsersPage extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      filter : {
        
      }
    };
  }

  loadNextPage() {
    const { actions } = this.props;
    const { userPage } = this.props;
    if(userPage.PageIndex < userPage.TotalPageCount){
      actions.fetchUsersAction(userPage.PageIndex + 1, userPage.PageSize, this.state.filter);
    }
  }

  loadPrevPage() {
    const { actions } = this.props;
    const { userPage } = this.props;
    if(userPage.PageIndex > 1){
      actions.fetchUsersAction(userPage.PageIndex - 1, userPage.PageSize, this.state.filter);
    }
  }

  onFilterChanged(filter){
    const { actions } = this.props;
    const { userPage } = this.props;
    actions.fetchUsersAction(1, userPage.PageSize, filter);
    this.setState({filter : filter});
  }


  render() {
    const { userPage } = this.props;
    const { authInfo } = this.props;
    const { IsAdmin } = this.props;

    return (
      <div className="container userspage-component" styleName="userspage-component">
          <UsersTable IsAdmin={IsAdmin} userPage={userPage} filterChanged={this.onFilterChanged.bind(this)} loadPrevPage={this.loadPrevPage.bind(this)} loadNextPage={this.loadNextPage.bind(this)}/>
      </div>
    );
  }
}

UsersPage.displayName = 'UsersPage';
UsersPage.propTypes = {};
UsersPage.defaultProps = {
  
};

export default cssmodules(UsersPage, styles);



// WEBPACK FOOTER //
// ./components/Users/UsersPage.js